<template>
  <Modal
    ref="modal"
    :title="title"
    size="xs"
    @hide="$emit('hide')"
  >
    <q-input
      v-model="inputValue"
      :label="label"
      outlined
      autofocus
      @keyup.enter="canOk && onOk()"
    />

    <template v-slot:actions>
      <q-btn flat label="Cancel" @click="onCancel" />
      <q-btn
        flat
        label="OK"
        color="primary"
        :disable="!canOk"
        @click="onOk"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from './Modal.vue';

export default {
  emits: ['cancel', 'hide', 'ok'],
  components: { Modal },
  props: {
    title: {
      type: String,
      default: 'Input',
    },
    label: {
      type: String,
      default: '',
    },
    isValid: {
      type: Function,
      default: v => v.length > 0,
    },
  },
  data() {
    return { inputValue: '' };
  },
  computed: {
    canOk() {
      return this.isValid(this.inputValue);
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onOk() {
      this.$emit('ok', this.inputValue);
      this.hide();
    },
    onCancel() {
      this.$emit('cancel');
      this.hide();
    },
  },
};
</script>
